module.exports = __webpack_public_path__ + "static/img/deals.d4876b69.svg";